import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ManagementFacadeService} from '@emm/management/services/management-facade.service';
import {Screen} from '@emm/core/models/screen.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-management',
    styleUrls: ['./management.component.scss'],
    templateUrl: './management.component.html',
    standalone: false
})
export class ManagementComponent implements OnInit {

    isLoading$ = this.managementService.isLoading$;
    screens$ = this.managementService.screens$;

    constructor(private managementService: ManagementFacadeService) {}

    ngOnInit(): void {
        this.managementService.init();
    }

    onScreenSelected(screen: Screen): void {
        localStorage.setItem('managementScreen', JSON.stringify(screen));
        this.managementService.changeScreen(screen);
    }

}
